import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import FlatButton from 'material-ui/FlatButton';
import { Box, Card, CardActions, CardMedia } from '@material-ui/core';
import { CardText, CardTitle } from 'material-ui';
import Grid from '@material-ui/core/Grid';
import { ActionInfoOutline } from 'material-ui/svg-icons/index.es';
import { bindActionCreators } from 'redux';
import OverviewContainer from '../dispatches/OverviewContainer';
import { mapOperations } from '../../redux/map';
import { configOperations } from '../../redux/config';
import { authOperations } from '../../redux/auth';
import threemodash from '../../images/IRWIN-3mo-dashboard.PNG';
import onemodash from '../../images/IRWIN-1mo-dashboard.PNG';
import quarantinedash from '../../images/IRWIN-quarantine-dashboard.png';

const styles = {
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: '0 0 50px',
    zIndex: '10',
    background: '#ffffff',
    borderTop: '1px solid #e5e5e5',
    borderBottom: '1px solid #e5e5e5'
  },
  headerControlsWrapper: {
    display: 'flex',
    flex: '1 0 300px',
    marginLeft: '36px'
  },

  sqlFilterBtn: {
    padding: '8px'
  },
  sqlClearFilterBtn: {
    minWidth: '28px'
  },
  sqlClearFilterIcon: {
    width: '18px',
    height: '18px'
  },
  boxStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    spacing: 0
  },
  mediaStyle: {
    paddingTop: '15%'
  }
};

class DashboardPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <OverviewContainer>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: '50vh' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Card item xs={6}>
                <CardMedia
                  style={styles.mediaStyle}
                  image={onemodash}
                  title="one month dashboard"
                />
                <CardTitle>
                  Critical Data Elements Dashboard (1 month view)
                </CardTitle>
                <CardText>
                  A dashboard that shows when critical data elements have been
                  updated after a 72-hour window, organized by Dispatch Center.
                  <br />
                  Data elements included:
                  <li>IncidentName,</li>
                  <li>UniqueFireIdentifier,</li>
                  <li>POOJurisdictionalUnit, and </li>
                  <li>POOProtectingUnit</li>
                  <br />
                  In order to appear, an Incident must be 72 hours old and less
                  than <u>1 month</u>. The changes that are reported are more
                  than 24 hours apart.
                  <b> Please note: Dashboard load time is ~2 minutes.</b>
                </CardText>
                <CardActions>
                  <FlatButton
                    icon={<LaunchIcon />}
                    label="Go To Dashboard"
                    style={styles.sqlClearFilterBtn}
                    onClick={() => {
                      window.open(
                        'https://geoplatform.maps.arcgis.com/apps/dashboards/88e3a9316f914d4fa310fea98e02140d'
                      );
                    }}
                  />
                  <FlatButton
                    icon={<ActionInfoOutline />}
                    label="Documentation (Wildfire.Gov)"
                    style={styles.sqlClearFilterBtn}
                    onClick={() => {
                      window.open(
                        'https://wildfireweb-prod-media-bucket.s3.us-gov-west-1.amazonaws.com/s3fs-public/2023-11/IRWIN%20Incident%20Critical%20Data%20Elements%20Change%20Detection%20Dashboard.pdf'
                      );
                    }}
                  />
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card item xs={6}>
                <CardMedia
                  style={styles.mediaStyle}
                  image={threemodash}
                  title="3 month dashboard"
                />
                <CardTitle>
                  Critical Data Elements Dashboard (3 month view)
                </CardTitle>
                <CardText>
                  A dashboard that shows when critical data elements have been
                  updated after a 72-hour window, organized by Dispatch Center.
                  <br />
                  Data elements included:
                  <li>IncidentName,</li>
                  <li>UniqueFireIdentifier,</li>
                  <li>POOJurisdictionalUnit, and </li>
                  <li>POOProtectingUnit</li>
                  <br />
                  In order to appear, an Incident must be 72 hours old and less
                  than <u>3 months</u>. The changes that are reported are more
                  than 24 hours apart.
                  <b> Please note: Dashboard load time is ~2 minutes.</b>
                </CardText>
                <CardActions>
                  <FlatButton
                    icon={<LaunchIcon />}
                    label="Go To Dashboard"
                    style={styles.sqlClearFilterBtn}
                    onClick={() => {
                      window.open(
                        'https://geoplatform.maps.arcgis.com/apps/dashboards/6b4bb57f1982493f8373f31d0dcc3338'
                      );
                    }}
                  />
                  <FlatButton
                    icon={<ActionInfoOutline />}
                    label="Documentation (Wildfire.Gov)"
                    style={styles.sqlClearFilterBtn}
                    onClick={() => {
                      window.open(
                        'https://wildfireweb-prod-media-bucket.s3.us-gov-west-1.amazonaws.com/s3fs-public/2023-11/IRWIN%20Incident%20Critical%20Data%20Elements%20Change%20Detection%20Dashboard.pdf'
                      );
                    }}
                  />
                </CardActions>
              </Card>
            </Grid>
            <Grid
              style={{  justifyContent: 'center' }}
              item
              xs={6}
            >
              <Card item xs={6}>
                <CardMedia
                  style={styles.mediaStyle}
                  image={quarantinedash}
                  title="quarantine dashboard"
                />
                <CardTitle>Quarantined Incidents Dashboard</CardTitle>
                <CardText>
                  A dashboard to identify quarantined incidents and their
                  related parent incidents, organized by Dispatch Center.
                </CardText>
                <CardActions>
                  <FlatButton
                    icon={<LaunchIcon />}
                    label="Go To Dashboard"
                    style={styles.sqlClearFilterBtn}
                    onClick={() => {
                      window.open(
                        'https://geoplatform.maps.arcgis.com/apps/dashboards/8da0a341246748a0bec3afe8db61e5d2'
                      );
                    }}
                  />
                  <FlatButton
                    icon={<ActionInfoOutline />}
                    label="Documentation (Coming Soon)"
                    style={styles.sqlClearFilterBtn}
                    disabled
                    onClick={() => {
                      window.open(
                        'https://www.wildfire.gov/application/irwin-integrated-reporting-wildfire-information'
                      );
                    }}
                  />
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </OverviewContainer>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config
});
const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...mapOperations,
      ...configOperations,
      ...authOperations
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/dashboards/DashboardPage.js